import Vue from 'vue'
import Router from 'vue-router'
//直播课堂
// import index from '@/components/index/index'
import Login from '@/views/login/Login.vue'
import Basis from '@/views/basisdata/basis.vue'
import Notice from "@/views/school/Notice.vue";
import School from "@/views/school/index.vue";
import Info from "../views/school/components/Info.vue";
import Classes from "../views/school/components/Classes.vue";
import picture from "../views/school/components/picture.vue";
import Teachermanger from "../views/school/components/Teachermanger.vue";
import Student from "../views/school/components/Student.vue";
import SchoolCourse from "../views/school/components/schoolCourse.vue";
import Departmen from "../views/school/components/Departmen.vue";
import TeacherBasic from "../views/bench/teacherBasic.vue";
import CourseViewHistory from "../views/school/components/CourseViewHistory.vue";
// import Bench from "../views/bench/Bench.vue";
// import CheckFirstlogin from "../views/login/checkFirstlogin.vue"
// import Forget from "../views/login/forget.vue"

Vue.use(Router)
// 控制路由重定向跳转路由改变
var redirects = '/school/info'
if (window.localStorage.getItem('roleId') == '-1003') {
	redirects = '/school/classes'
}
export default new Router({
	routes: [
		// {
		// 	path: '/',
		// 	name: 'index',
		// 	component: index,
		// 	meta: {
		// 		keepAlive: true,//是否缓存
		// 		isBack: true,//是否保存状态
		// 		title: '未来学校',//title
		// 	}
		// },
		{
			path: '/user/login',
			name: 'login',
			component: Login,
			meta: {
				title: "登录"
			}
		},
		// {
		// 	path: '/user/checkFirstlogin',
		// 	name: 'checkFirstlogin',
		// 	component: CheckFirstlogin,
		// 	meta: {
		// 		title: '设置密保问题'
		// 	}
		// },
		// {
		// 	path:'/forget',
		// 	name:'forget',
		// 	component: Forget,
		// 	meta: {
		// 		title: '忘记密码'
		// 	}
		// },
		// {
		// 	path: '/bench',
		// 	name: 'bench',
		// 	component: Bench,
		// 	meta: {
		// 		// keepAlive: true,
		// 		auth: true,
		// 		title: "工作台",
		// 		role: []
		// 	}
		// },
		{
			path: '/teacherbasic',
			name: 'teacherbasic',
			component: TeacherBasic,
			meta: {
				auth: true,
				title: "修改信息",
			}
		},
		{
			path: '/',
			name: 'basis',
			component: Basis,
			redirect: '/basicmanager',
			meta: {
				auth: true,
				title: "基础数据管理"
			},
			children: [
				{
					path: '/basicmanager',
					name: 'school',
					component: School,
					redirect: redirects,
					meta: {
						auth: true,
						title: "基础管理"
					},
					children: [
						{
							path: '/school/course',
							name: 'course',
							component: SchoolCourse,
							meta: {
								auth: true,
								title: "必修课程"
							}
						},
						{
							path: '/school/info',
							name: 'info',
							component: Info,
							meta: {
								auth: true,
								title: "基础信息"
							}
						},
						{
							path: '/school/classes',
							name: 'classes',
							component: Classes,
							meta: {
								auth: true,
								title: "班级管理"
							}
						},
						{
							path: '/school/picture',
							name: 'picture',
							component: picture,
							meta: {
								auth: true,
								title: "班级集体照"
							}
						},
						{
							path: '/school/teachermanger',
							name: 'teachermanger',
							component: Teachermanger,
							meta: {
								auth: true,
								title: "教师管理"
							}

						},
						{
							path: '/school/student',
							name: 'student',
							component: Student,
							meta: {
								auth: true,
								title: "学生管理"
							}
						},
            {
              path: '/school/department',
              name: 'departmen',
              component: Departmen,
              meta: {
                auth: true,
                title: "科室管理"
              }
            },
            {
              path: '/course/view/history',
              name: 'CourseViewHistory',
              component: CourseViewHistory,
              meta: {
                auth: true,
                title: "观看记录"
              }
            }
					]
				},
				{
					path: '/notice',
					name: 'notice',
					component: Notice,
					meta: {
						auth: true,
						title: "公告管理"
					}
				}
			]
		},
		// {
		// 	path:'/notice',
		// 	name: 'notice',
		// 	component: Notice
		// }

	],
	// 页面滚动距离单一保持
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			if (from.meta.keepAlive) {
				from.meta.savedPosition = document.body.scrollTop
			}
			return {
				x: 0,
				y: to.meta.savedPosition || 0
			}
		}
	},


})

// Router.beforeEach((to, from, next) => {
// 	// 判断用户是否访问的登陆页，如果是就直接放行
// 	if (to.path === '/login') return next()
// 	//从sessionStorage取出token，并赋值给tokenStr
// 	const tokenStr = window.sessionStorage.getItem('token')
// 	// 通过判断tokenStr,
// 	if (!tokenStr) return next('/login')
// 	next()
// })




// WEBPACK FOOTER //
// ./src/router/index.js